export default __webpack_public_path__ + "static/media/footerRightPolygon.73a40858.svg";